import type { Measure, CohortAggregation } from '../services/measure.service';
import type { PipelineNode } from '../services/pipelineNode.service';
import type { Dimension } from '../services/dimension.service';

const COHORT_AGGREGATION_LABELS: Record<CohortAggregation, string> = {
  COUNT_NON_ZERO_COHORT_CONDITION: 'Count Still-Active',
  COUNT_ZERO_COHORT_CONDITION: 'Count Deactivated',
  COUNT_REACTIVATED_CONDITION: 'Count Reactivated',
  COUNT_FIRST_ACTIVITY_CONDITION: 'Count New',
  SUM_COHORT_CONDITION: 'Sum',
};

export function formatFormula(
  measure: Measure,
  nodesById: Record<string, PipelineNode>,
  measuresById?: Record<string, Measure>,
  dimensionsById?: Record<string, Dimension>,
): string {
  if (measure.metric_type === 'CALCULATED' && measure.formula) {
    return measure.formula;
  }

  if (measure.metric_type === 'COHORT') {
    const aggLabel = measure.aggregator
      ? COHORT_AGGREGATION_LABELS[measure.aggregator as CohortAggregation] || measure.aggregator
      : 'Unknown';

    const activityMeasure = measure.activity_measure_id && measuresById
      ? measuresById[measure.activity_measure_id]
      : null;
    const activityName = activityMeasure?.name || 'Unknown';

    const cohortDimension = measure.cohort_dimension_id && dimensionsById
      ? dimensionsById[measure.cohort_dimension_id]
      : null;
    const dimensionName = cohortDimension?.name || 'Unknown';

    return `${aggLabel}: ${activityName} by ${dimensionName}`;
  }

  // Basic metric: show aggregator and entity/column
  const aggregator = measure.aggregator || 'SUM';
  const node = measure.pipeline_node_id
    ? nodesById[measure.pipeline_node_id]
    : null;
  const nodeName = node?.label || node?.name || 'Unknown';

  let columnName = 'Unknown';
  if (node && measure.field_id) {
    const field = node.fields?.find(f => f.id === measure.field_id);
    columnName = field?.label || field?.name || 'Unknown';
  }

  return `${aggregator}(${nodeName}.${columnName})`;
}
